import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { IconName } from '@thiememeulenhoff/types';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { duoIconColors, getIcon, initializeIconLibrary } from './icon.library';
import { iconStyles, tag } from './icon.styles';

initializeIconLibrary();

@customElement(tag)
export class IconComponent extends TmElement {
  static override styles = [iconStyles];

  @property({ type: String })
  name: IconName = 'chevron-right';

  addPart(icon: string) {
    return icon.replace('<svg ', '<svg part="iconSvg" data-test="iconSvg" ');
  }

  clearStyle(icon: string) {
    const regex = /style="(.*?)"/gm;
    const replaced = '';
    return icon.replace(regex, replaced);
  }

  addDuoColor(icon: string) {
    const key = this.name as string;

    if (duoIconColors[key]) {
      return icon.replace(
        'class="fa-primary" fill="currentColor"',
        `class="fa-secondary" fill="${duoIconColors[key]}"`,
      );
    }

    return icon;
  }

  override render() {
    const icon = getIcon(this.name);
    if (!icon) throw new Error(`Icon with name "${this.name}" not found.`);
    return unsafeHTML(this.clearStyle(this.addPart(this.addDuoColor(icon))));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-icon': IconComponent;
  }
}
